<template>
  <span :class="itemClass">
    <img :src="'/images/logo-' + alignment + '.svg'" :width="width" :height="height" alt="Tarfin" />
  </span>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    width: {
      type: [Number, String],
      default: null
    },
    height: {
      type: [Number, String],
      default: 30
    },
    itemClass: {
      type: String,
      required: false
    },
    alignment: {
      type: String,
      default: 'vertical'
    }
  }
}
</script>

<style scoped></style>
